import { useState, useRef } from 'react';
import useElementToPdf from '../utils/useElementToPdf';
import api from '../utils/api';
import { toast } from 'sonner';

/**
 * Encapsulates receipt-print state for revenues:
 *  - language toggle (ar/en/bilingual)
 *  - calling /print-receipt endpoint (which enforces the print-count limit)
 *  - react-to-print setup
 */
export default function useReceiptPrint(initialLanguage) {
  const [printingReceiptId, setPrintingReceiptId] = useState(null);
  const [receiptData, setReceiptData] = useState(null);
  const [receiptLanguage, setReceiptLanguage] = useState(initialLanguage);
  const [bilingualReceipt, setBilingualReceipt] = useState(false);
  const printRef = useRef();

  const triggerPrint = useElementToPdf({
    contentRef: printRef,
    documentTitle: `إيصال_${receiptData?.receipt_number || 'receipt'}`,
    pageStyle: `
      @page { size: 80mm auto; margin: 5mm; }
      @media print {
        body {
          -webkit-print-color-adjust: exact !important;
          print-color-adjust: exact !important;
          direction: ${bilingualReceipt ? 'rtl' : receiptLanguage === 'ar' ? 'rtl' : 'ltr'};
        }
        .print\\:hidden { display: none !important; }
      }
    `,
  });

  const printReceipt = async (revenueId) => {
    setPrintingReceiptId(revenueId);
    try {
      const res = await api.post(`/revenues/${revenueId}/print-receipt`);
      setReceiptData(res.data.receipt);
      toast.success('تم إنشاء الإيصال بنجاح');
      setTimeout(() => triggerPrint(), 500);
    } catch (error) {
      const msg = error.response?.data?.detail || 'فشل طباعة الإيصال';
      toast.error(msg);
    } finally {
      setPrintingReceiptId(null);
    }
  };

  return {
    printRef,
    receiptData,
    setReceiptData,
    receiptLanguage,
    setReceiptLanguage,
    bilingualReceipt,
    setBilingualReceipt,
    printingReceiptId,
    printReceipt,
    triggerPrint,
  };
}
